import React from "react";

const Loader = () => {
  return (
    <div className="box-errors">
      <h2>Loading...</h2>
    </div>
  );
};

export default Loader;
